// Status code → display name, for the places that receive a bare code.
//
// The codes are the spine of the app and have not changed in twenty years, so a
// static map is honest here — and it is cheaper than the alternative: fetching
// the name alongside the code in the claim search cost +2.7ms at the 500-row cap
// for nothing but a tooltip (services/claims.js, 13 Aug 2026).
//
// The authority is STATUSES in services/claimStatus.js. ClaimStatusTab.jsx keeps
// its own copy of this map; fold it into this one next time that file is open.
export const STATUS_NAMES = {
  R: "Requested",
  I: "Inspected",
  Q: "Quoted",
  A: "Accepted",
  D: "Declined",
  C: "Completed",
};

export const statusName = (code) => STATUS_NAMES[code] || code;
